/**
 * @module components\TxnHistory
 */
 import Vue from 'vue';
 import Component from 'vue-class-component';
 import { required,numeric, maxLength } from "vuelidate/lib/validators";
 import LoaderMobile from '@/services/loaderMobile';
 import sToast from '@/services/sToast';
import core from '@/services/core';
import store from '@/store';
import * as XLSX from "xlsx";
import utilities from "@/utilities";
import _ from "lodash";
 
 
 @Component({
   validations: {
    ftrNo: { required,numeric,maxLength:maxLength(32) },
    finoClientId: { required }
   },
 })
 export default class UploadCd extends Vue {
    ftrNo="";
    depositFile:any=[];
    finoClientId="";
    itemsModules=[];
    rules= [
        value => !!value || 'File is required',
        value => (!!value && value.size < 5000000) || 'File size should be less than 5 MB',
        value => (!!value && (value.type =='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || value.type =='application/vnd.ms-excel')) || 'Please upload a valid file'
    ];
    isValidFile(){
        if(this.depositFile && ( this.depositFile['type'] =='application/vnd.ms-excel'|| this.depositFile['type']=='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') && this.depositFile['size']<5000000){
            return false;
        } 
        return true;
    }
    checkMgNumber(){
      if(this.$v.$invalid){
        this.$v.$touch();
        return;
      }
        const filereader = new FileReader();
        filereader.onloadend = (event: any) => {
          if (event.target.readyState === FileReader.DONE) {
            this.checkExtensions(this.depositFile, event);
          }
        };
        const blob:any = this.depositFile.slice(0, 4);
        filereader.readAsArrayBuffer(blob);
    }
    checkExtensions(file: any,eventReader: any) {
        const uint = new Uint8Array(eventReader.target.result);
        const bytes: any = [];
        uint.forEach((byte: any) => {
          bytes.push(byte.toString(16));
        });
        const hex = bytes.join('').toUpperCase();
        let scannedFileType=this.getMimetype(hex, this.depositFile['type']); 
        if(scannedFileType=='Unknown filetype'){
            this.showFileErrorMsg()
            return;
        }
        //this.uploadFile(file: any,eventReader: any);
        this.checkFilesHeaders(file,eventReader);
      }
      showFileErrorMsg(){
        sToast.show({
            message: "Please upload a valid file",
            intent: "error",
            timeout: 6000
          });
      }
      getMimetype = (signature: any, type: string) => {
          if (signature === '504B34') {
            return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          } else {
            return 'Unknown filetype';
          }
      };
      get fileFormats(){
        let validColumn=[];
        if(this.staticData.payload.fileFormats){
        let fileFormatClient=this.staticData.payload.fileFormats.filter((obj)=>{
          return obj.finoClientId==this.finoClientId  && obj.requestFor=='DEMAND_UPLOAD';
        });
        if(fileFormatClient.length>0){
          let clientMeta=_.orderBy(fileFormatClient[0]['metaData'],'order');
          for(let i=0;i<clientMeta.length;i++){
            validColumn.push(clientMeta[i].colName)
          }
        }
      }
        return validColumn                      
      }
      checkFilesHeaders(file: any,eventReader: any){
          let reader1 = new FileReader();
						        reader1.onload = (e)=> {
                                let fileValid=[];
                                fileValid=this.fileFormats;//["Branch ID", "Branch Name", "Delivery Date(DD-MM-YYYY)", "Amount"];
                                var workbook = XLSX.read(e.target.result, {cellDates:true,type:'binary'});   
                                let first_sheet_name = workbook.SheetNames[0];
                                let worksheet = workbook.Sheets[first_sheet_name];
                                let xlsData=XLSX.utils.sheet_to_json(worksheet,{ header: "A" });
                                let isHeaders=false;
                                if(xlsData.length){
                                    let xlsKeys= Object.values(xlsData[0]);
                                                        if(fileValid.length==xlsKeys.length){
                                                            isHeaders=false;
                                                            for(let i=0;i<fileValid.length;i++){
                                                                if(fileValid[i]!=xlsKeys[i] && !isHeaders){
                                                                    isHeaders=true;
                                                                }
                                                            }
                                                        }else{
                                                            isHeaders=true;
                                                        }   
                                }else{
                                  isHeaders=true;
                                }
            if(isHeaders){
              this.showFileErrorMsg();
                return;
            }
            this.uploadFile();
                            }
                            reader1.readAsBinaryString(file);
        }
      get reqModule(){
          return store.getters.tabKeyGet.requestModule
      }
      enableRevFile=false;
      uploadFileRes=null;
      uploadFile(){
        const formData = new FormData();
        formData.append('token',store.getters.sessLoginDataGet.sessionId);
        formData.append('requestModule','CMS');
        formData.append('requestType','WEB');
        formData.append('merchantClientId',store.getters.sessLoginDataGet.clientId);
        formData.append('requestFor','DEMAND_UPLOAD');
        formData.append('aggId',this.moduleClient.length>0? this.moduleClient[0].agg_id:'');//Select box added on UI for dynamic clients and aggId
        formData.append('finoClientId',this.finoClientId);
        formData.append('tabKey',"CD");
        formData.append('ftrNo',this.ftrNo);
        formData.append('file1',this.depositFile);
        this.enableRevFile=false;
        this.lastUploadClientData={aggId:this.moduleClient.length>0? this.moduleClient[0].agg_id:'',finoClientId:this.finoClientId};
        core.post({data:formData,url:"uploadFile",method:'POST'}).then((response:any)=>{
          this.enableRevFile=true;
          this.uploadFileRes=response;
           this.resetFields();
        }).catch((error:any)=>{
		    LoaderMobile.hide();
        })
      }
      ftrStatusResponse:any=null;
      lastUploadClientData={aggId:"",finoClientId:""};
      checkFtrStatus(){
        if(this.$v.$invalid){
            this.$v.$touch();
            return;
          }
          this.ftrStatusResponse=null;
          let request={"token": store.getters.sessLoginDataGet.sessionId,
           "merchantClientId": store.getters.sessLoginDataGet.clientId,
           "requestModule": 'FTR', "filter_A": this.ftrNo,
           "filter_B": "","filter_C": "","filter_D": "","filter_E": "",
           "tabKey": "CD", "aggId":this.moduleClient.length>0? this.moduleClient[0].agg_id:'', "finoClientId":this.finoClientId};
          core
            .post({
              data: request,
              url: 'valFetchData',
              method: 'post'
            })
          .then(response => {
            this.ftrStatusResponse=response;
          })
          .catch(error => {
            
          });
      }
      downloadRevFile(type){
        if(type=='DEMAND_UPLOAD' && this.lastUploadClientData.aggId=="" && this.lastUploadClientData.finoClientId=="" ){
          this.lastUploadClientData={aggId:this.moduleClient.length>0? this.moduleClient[0].agg_id:'',finoClientId:this.finoClientId};
        }
        let request={"token":store.getters.sessLoginDataGet.sessionId,
          "requestModule":"CMS","requestType":"WEB",
          "merchantClientId":store.getters.sessLoginDataGet.clientId,
           "requestFor":type,
            "aggId":this.lastUploadClientData.aggId,"finoClientId":this.lastUploadClientData.finoClientId,
             "tabKey": "CD","requestId":type!='DEMAND_UPLOAD'?this.uploadFileRes['payload'].requestId:""}
        core
          .post({
            data: request,
            url: 'demandDownload',
            method: 'post'
          })
        .then(response => {
            if(type=='DEMAND_UPLOAD'){
                utilities.downloadFileFromB64(
                    response.payload.fileByte,
                    this.moduleClient.length>0?`${this.moduleClient[0].displayName}Sample.xlsx`:'Sample.xlsx'
                  );
            }else{
                utilities.downloadFileFromB64(
                    response.payload.fileByte,
                    request.requestId + ".xlsx"
                  );
            }
            
        })
        .catch(error => {
          
        }); 
      }
      resetFields(){
        this.depositFile=[];
        this.ftrNo="";
        this.ftrStatusResponse=null;
        this.finoClientId="";
        this.$refs['form'].reset();
        this.$v.$reset();
      }
      get moduleClient(){
        return this.itemsModules.filter(obj=>{
          return obj.value==this.finoClientId
        })
      }
      get staticData(){
        return store.getters.staticDataGet;
        }
      mounted(){
        this.itemsModules=_.orderBy(this.staticData.payload.cdSearchModule,'displayName');
        if(this.itemsModules.length==1)
        {
          this.finoClientId=this.itemsModules[0]['value']
        }

      }
 }
 